import type { BackendGameListItem, BackendGameConfigResponse } from '@core/types/backend-game.types';
import { usePreferencesStore } from '../../store/preferencesStore';
import { AuthService } from '../auth/AuthService';

const DEFAULT_API_BASE = 'https://pixi.cyberyokai.com/api/v1/games';

function getApiBase(): string {
  const url = usePreferencesStore.getState().backendApiUrl;
  if (!url) return DEFAULT_API_BASE;
  // Normalize: if user stored just the domain, append the API path
  if (url.endsWith('/') || !url.includes('/api/')) {
    return url.replace(/\/+$/, '') + '/api/v1/games';
  }
  return url;
}

function getAuthHeaders(): HeadersInit {
  const token = AuthService.getStoredToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function fetchGamesList(): Promise<BackendGameListItem[]> {
  const res = await fetch(getApiBase(), { headers: getAuthHeaders() });
  if (!res.ok) throw new Error(`Failed to fetch games list: ${res.status}`);
  const json = await res.json();
  if (!json.success) throw new Error('API returned success=false');
  return json.data;
}

export async function fetchGameConfig(gameName: string): Promise<BackendGameConfigResponse> {
  const res = await fetch(`${getApiBase()}/${gameName}/config`, { headers: getAuthHeaders() });
  if (!res.ok) throw new Error(`Failed to fetch game config: ${res.status}`);
  const json = await res.json();
  if (!json.success) throw new Error('API returned success=false');
  return json.data;
}
